import { i18n } from '../../i18n/i18n';

/** Human countdown labels for on-air / up-next. */

export function formatCountdown(ms: number, prefix: 'ends in' | 'in'): string {
  const ending = prefix === 'ends in';
  if (!Number.isFinite(ms) || ms <= 0) {
    return i18n.t(ending ? 'schedule:countdown.endingNow' : 'schedule:countdown.now');
  }
  const totalMinutes = Math.round(ms / 60_000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours <= 0) {
    return i18n.t(ending ? 'schedule:countdown.endsInMinutes' : 'schedule:countdown.inMinutes', {
      minutes,
    });
  }
  if (minutes === 0) {
    return i18n.t(ending ? 'schedule:countdown.endsInHours' : 'schedule:countdown.inHours', {
      hours,
    });
  }
  return i18n.t(
    ending ? 'schedule:countdown.endsInHoursMinutes' : 'schedule:countdown.inHoursMinutes',
    { hours, minutes },
  );
}

/**
 * Next occurrence of HH:mm on or after `from` (browser local), optionally constrained
 * to contract daysOfWeek (empty = every day).
 */
export function nextOccurrenceMs(
  startLocalTime: string,
  daysOfWeek: number[],
  from: Date = new Date(),
): number | null {
  const [h, m] = startLocalTime.split(':').map(Number);
  for (let offset = 0; offset < 8; offset += 1) {
    const candidate = new Date(from);
    candidate.setDate(from.getDate() + offset);
    candidate.setHours(h ?? 0, m ?? 0, 0, 0);
    if (candidate.getTime() <= from.getTime()) continue;
    const day = candidate.getDay();
    if (daysOfWeek.length === 0 || daysOfWeek.includes(day)) {
      return candidate.getTime() - from.getTime();
    }
  }
  return null;
}

/** Milliseconds until end of the active window (handles overnight). */
export function msUntilWindowEnd(
  startLocalTime: string,
  endLocalTime: string,
  from: Date = new Date(),
): number {
  const [eh, em] = endLocalTime.split(':').map(Number);
  const end = new Date(from);
  end.setHours(eh ?? 0, em ?? 0, 0, 0);
  const startMinutes =
    Number(startLocalTime.slice(0, 2)) * 60 + Number(startLocalTime.slice(3, 5));
  const endMinutes = (eh ?? 0) * 60 + (em ?? 0);
  const nowMinutes = from.getHours() * 60 + from.getMinutes();

  if (startMinutes < endMinutes) {
    if (end.getTime() <= from.getTime()) end.setDate(end.getDate() + 1);
  } else if (nowMinutes <= endMinutes) {
    // Overnight window, still in the morning leg — end is today.
  } else {
    end.setDate(end.getDate() + 1);
  }
  return Math.max(0, end.getTime() - from.getTime());
}
